import { Component, input, ViewEncapsulation } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

import type { AbsenceCostCalculatorProps } from '../absence-cost';
import { AbsenceCostComponent } from '../absence-cost';

@UntilDestroy()
@Component({
  selector: 'absence-cost-wrapper',
  templateUrl: './absence-cost-wrapper.component.html',
  styleUrls: ['./absence-cost-wrapper.component.scss'],
  imports: [AbsenceCostComponent],
  encapsulation: ViewEncapsulation.None
})
export class AbsenceCostWrapper {
  props = input({} as AbsenceCostCalculatorProps, {
    transform: (value: string) => JSON.parse(value) as AbsenceCostCalculatorProps
  });
}
